import React, { Component, useState, useEffect } from 'react';
import './TreinoAppLanding.css';

export default function App({PAinelAdm}) {
  const whatsappNumber = '5599984136843';
  const whatsappLink = `https://wa.me/${whatsappNumber}`;
  const email = 'contato@treinaapp.com';
  const site = 'https://www.treinaapp.pro';
function abrirLink() {
  window.open(`https://wa.me/${whatsappNumber}`, "_blank");
}
  // 💡 Implementação da lógica de animação e smooth scroll com useEffect
    useEffect(() => {
        // ... (Aqui você adaptaria a lógica do <script> para React)
        // Por exemplo, usando a API IntersectionObserver no useEffect
        // e gerenciando o state para o scroll
        
        // Exemplo simplificado (você deve adaptar o código original aqui)
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-fade-in');
                }
            });
        }, observerOptions);

        document.querySelectorAll('.feature-card, .pricing-card, .benefits-list li').forEach((el) => {
            observer.observe(el);
        });
        
        // Cleanup function
        return () => {
             // Limpar o observer ao desmontar o componente, se necessário
             document.querySelectorAll('.feature-card, .pricing-card, .benefits-list li').forEach((el) => {
                observer.unobserve(el);
            });
        };
    }, []); // Array de dependências vazio para rodar apenas uma vez ao montar
  // Renan
  const cardStyle = {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    marginBottom: '20px'
  };

const centeredImageStyle = { 
    width: '70%', 
    borderRadius: '10px',
    display: 'block',    // Torna a imagem um elemento de bloco
    margin: '0 auto'     // Centraliza horizontalmente
};
  

  const cardTitleStyle = { color: '#e84545', fontSize: '1.3rem', marginBottom: '10px' };
  const cardTextStyle = { fontSize: '1rem', lineHeight: '1.6' };

  return (
   <>
 <div>
  <section className="hero">
    <div className="container">
      <div className="hero-content animate-fade-in">
        <div className="hero-badge">
          <svg className="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
            <rect x={5} y={2} width={14} height={20} rx={2} ry={2} />
            <line x1={12} y1={18} x2="12.01" y2={18} />
          </svg>
          Plataforma Completa para Fitness
        </div>
        <h1>
          Transforme treinos em <span className="text-gradient">lucro recorrente</span>
        </h1>
        <p>
          A plataforma que permite academias e personal trainers venderem treinos personalizados 
          com cobrança automática e aumentem o lucro todos os meses
        </p>
        <div className="hero-buttons">
          <a href="https://wa.me/5599984136843" target="_blank" className="btn btn-primary">
            🚀 Quero Testar Grátis
            <svg className="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
              <line x1={5} y1={12} x2={19} y2={12} />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </a>
          <button className="btn btn-outline" onClick={PAinelAdm}>
            🔧 Acessar Painel
          </button>
        </div>
        <div className="hero-stats">
          <div>+500 profissionais</div>
          <div>⭐ 4.9/5 avaliação média</div>
          <div>💰 +R$2M em treinos vendidos</div>
        </div>
        <div className="hero-image">
          <img src='../../assets/TATreinoapp.png' alt="Mockup TreinaAPP" style={{ marginTop: '30px', width: '50%', maxWidth: '300px', borderRadius: '10px' }} />
        </div>
      </div>
    </div>
  </section>
  {/* Features Section */}
  <section className="features">
    <div className="container">
      <div className="section-header">
        <h2>
          Simples, moderno e <span className="text-gradient">100% automatizado</span>
        </h2>
        <p>Tudo que você precisa para transformar treinos em um negócio lucrativo</p>
      </div>
      <div className="features-showcase">
        <img src='../../assets/TApainel1.png' alt="Painel Administrativo TreinoAPP"  style={centeredImageStyle} />
      </div>
      <div className="features-grid">
        <div className="feature-card">
          <div className="feature-icon">
            <svg className="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
              <rect x={5} y={2} width={14} height={20} rx={2} ry={2} />
            </svg>
          </div>
          <h3>Criação Intuitiva</h3>
          <p>Crie treinos personalizados em minutos pelo painel web profissional</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">
            <svg className="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
              <polyline points="17 1 21 5 17 9" />
              <path d="M3 11V9a4 4 0 0 1 4-4h14" />
              <polyline points="7 23 3 19 7 15" />
              <path d="M21 13v2a4 4 0 0 1-4 4H3" />
            </svg>
          </div>
          <h3>Acompanhamento Real-Time</h3>
          <p>Alunos acompanham exercícios, séries e repetições ao vivo no app</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">
            <svg className="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
              <circle cx={12} cy={12} r={10} />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          </div>
          <h3>Controle de Descanso</h3>
          <p>Timer automático de descanso entre séries para máxima eficiência</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">
            <svg className="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
              <polyline points="17 6 23 6 23 12" />
            </svg>
          </div>
          <h3>Evolução e Histórico</h3>
          <p>Gráficos de progresso e histórico completo de treinos</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">
            <svg className="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
            </svg>
          </div>
          <h3>Medidas Corporais</h3>
          <p>Acompanhe medidas e evolução física dos seus alunos</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">
            <svg className="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
              <rect x={1} y={4} width={22} height={16} rx={2} ry={2} />
              <line x1={1} y1={10} x2={23} y2={10} />
            </svg>
          </div>
          <h3>Cobrança Automática</h3>
          <p>Integração com Mercado Pago para mensalidades recorrentes</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">
            <svg className="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>
          <h3>App Personalizado</h3>
          <p>Aplicativo com sua logo e identidade visual</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">
            <svg className="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
          </div>
          <h3>100% Seguro</h3>
          <p>Dados criptografados e conformidade com LGPD</p>
        </div>
      </div>
      <div className="features-showcase">
        <img src='../../assets/TAfrenteApp.gif' alt="TreinoAPP Mobile Showcase"  style={centeredImageStyle}/>
      </div>
    </div>
  </section>
  {/* Benefits Section */}
  <section className="benefits">
    <div className="container">
      <div className="section-header">
        <h2>
          Por que escolher o <span className="text-gradient">TreinoAPP?</span>
        </h2>
      </div>
      <div className="benefits-grid">
        <div className="benefits-image">
          <img src='../../assets/TAPessoasApp.jpg' alt="Personal Trainer e Cliente" />
        </div>
        <div>
          <ul className="benefits-list">
            <li>
              <div className="check-icon">✓</div>
              <div>
                <strong>Lucro Recorrente Automático</strong><br />
                Receba mensalidades automaticamente sem precisar cobrar manualmente
              </div>
            </li>
            <li>
              <div className="check-icon">✓</div>
              <div>
                <strong>Mais Tempo para Treinar</strong><br />
                Pare de perder tempo com planilhas e foque no que importa: treinar seus alunos
              </div>
            </li>
            <li>
              <div className="check-icon">✓</div>
              <div>
                <strong>Escale Seu Negócio</strong><br />
                Atenda dezenas de alunos simultaneamente sem aumentar sua carga de trabalho
              </div>
            </li>
            <li>
              <div className="check-icon">✓</div>
              <div>
                <strong>Profissionalismo</strong><br />
                Impressione seus clientes com tecnologia de ponta e acompanhamento profissional
              </div>
            </li>
            <li>
              <div className="check-icon">✓</div>
              <div>
                <strong>Suporte Dedicado</strong><br />
                Equipe pronta para ajudar você e seus alunos sempre que precisarem
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  {/* Pricing Section */}
  <section className="pricing">
    <div className="container">
      <div className="section-header">
        <h2>
          Planos que cabem no seu <span className="text-gradient">bolso</span>
        </h2>
        <p>Escolha o plano ideal para o seu negócio fitness</p>
      </div>
      <div className="pricing-category">
        <h3>Personal Trainer</h3>
        <div className="pricing-grid">
          <div className="pricing-card">
            <h3>Starter</h3>
            <p>Para quem está começando</p>
            <div className="price">R$ 30<span>/mês</span></div>
            <ul>
              <li><span className="check-icon">✓</span> Até 30 alunos ativos</li>
              <li><span className="check-icon">✓</span> App personalizado</li>
              <li><span className="check-icon">✓</span> Cobrança automática</li>
              <li><span className="check-icon">✓</span> Suporte por email</li>
            </ul>
            <a href="https://wa.me/5599984136843" target="_blank" className="btn btn-outline" style={{width: '100%'}}>Começar Agora</a>
          </div>
          <div className="pricing-card highlighted">
            <h3>Pro</h3>
            <p>Mais popular entre PTs</p>
            <div className="price">R$ 50<span>/mês</span></div>
            <ul>
              <li><span className="check-icon">✓</span> Até 100 alunos ativos</li>
              <li><span className="check-icon">✓</span> App personalizado</li>
              <li><span className="check-icon">✓</span> Cobrança automática</li>
              <li><span className="check-icon">✓</span> Suporte prioritário</li>
              <li><span className="check-icon">✓</span> Relatórios avançados</li>
            </ul>
            <a href="https://wa.me/5599984136843" target="_blank" className="btn btn-primary" style={{width: '100%'}}>Começar Agora</a>
          </div>
          <div className="pricing-card">
            <h3>Elite</h3>
            <p>Para profissionais estabelecidos</p>
            <div className="price">R$ 100<span>/mês</span></div>
            <ul>
              <li><span className="check-icon">✓</span> Alunos ilimitados</li>
              <li><span className="check-icon">✓</span> App personalizado</li>
              <li><span className="check-icon">✓</span> Cobrança automática</li>
              <li><span className="check-icon">✓</span> Suporte VIP</li>
              <li><span className="check-icon">✓</span> Relatórios avançados</li>
              <li><span className="check-icon">✓</span> Integrações premium</li>
            </ul>
            <a href="https://wa.me/5599984136843" target="_blank" className="btn btn-outline" style={{width: '100%'}}>Começar Agora</a>
          </div>
        </div>
      </div>
      <div className="pricing-category">
        <h3>Academias</h3>
        <div className="pricing-grid">
          <div className="pricing-card">
            <h3>Basic</h3>
            <p>Para academias pequenas</p>
            <div className="price">R$ 100<span>/mês</span></div>
            <ul>
              <li><span className="check-icon">✓</span> Até 200 alunos ativos</li>
              <li><span className="check-icon">✓</span> 3 personal trainers</li>
              <li><span className="check-icon">✓</span> App com sua marca</li>
              <li><span className="check-icon">✓</span> Cobrança automática</li>
              <li><span className="check-icon">✓</span> Dashboard gerencial</li>
            </ul>
            <a href="https://wa.me/5599984136843" target="_blank" className="btn btn-outline" style={{width: '100%'}}>Começar Agora</a>
          </div>
          <div className="pricing-card highlighted">
            <h3>Premium</h3>
            <p>Melhor custo-benefício</p>
            <div className="price">R$ 150<span>/mês</span></div>
            <ul>
              <li><span className="check-icon">✓</span> Até 500 alunos ativos</li>
              <li><span className="check-icon">✓</span> 10 personal trainers</li>
              <li><span className="check-icon">✓</span> App com sua marca</li>
              <li><span className="check-icon">✓</span> Cobrança automática</li>
              <li><span className="check-icon">✓</span> Dashboard gerencial</li>
              <li><span className="check-icon">✓</span> Relatórios completos</li>
              <li><span className="check-icon">✓</span> Suporte prioritário</li>
            </ul>
            <a href="https://wa.me/5599984136843" target="_blank" className="btn btn-primary" style={{width: '100%'}}>Começar Agora</a>
          </div>
          <div className="pricing-card">
            <h3>Enterprise</h3>
            <p>Para grandes redes</p>
            <div className="price">Custom</div>
            <ul>
              <li><span className="check-icon">✓</span> Alunos ilimitados</li>
              <li><span className="check-icon">✓</span> Personal trainers ilimitados</li>
              <li><span className="check-icon">✓</span> Apps customizados</li>
              <li><span className="check-icon">✓</span> Cobrança automática</li>
              <li><span className="check-icon">✓</span> Dashboard gerencial</li>
              <li><span className="check-icon">✓</span> Relatórios completos</li>
              <li><span className="check-icon">✓</span> Gerente de conta dedicado</li>
            </ul>
            <a href="https://wa.me/5599984136843" target="_blank" className="btn btn-outline" style={{width: '100%'}}>Falar com Vendas</a>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* CTA Section */}
  <section className="cta">
    <div className="container">
      <div className="cta-box">
        <div className="cta-content">
          <h2>Pronto para transformar seu negócio fitness?</h2>
          <p>Junte-se a centenas de profissionais que já estão lucrando com treinos personalizados automatizados</p>
          <div className="cta-buttons">
            <a href="https://wa.me/5599984136843" target="_blank" className="btn btn-secondary">
              <svg className="icon-svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
              Falar com Especialista
              <svg className="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                <line x1={5} y1={12} x2={19} y2={12} />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </a>
            <button className="btn btn-outline" onClick={abrirLink}>Ver Demonstração</button>
          </div>
          <div className="trust-badges">
            <div className="trust-badge">Teste grátis por 7 dias</div>
            <div className="trust-badge">Sem cartão de crédito</div>
            <div className="trust-badge">Cancele quando quiser</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

   </>
  );
}
